import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { siteInfo } from '../data/siteInfo';

const LoadingScreen = ({ onFinished }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onFinished && onFinished(), 600);
    }, 2200);
    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="loading"
          initial={{ y: 0 }}
          exit={{ y: '-100%' }}
          transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'var(--navy-deep)',
            zIndex: 100000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px'
          }}
        >
          <motion.div
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ color: 'var(--gold)' }}
          >
            <svg width="56" height="56" viewBox="0 0 48 48" fill="none" aria-hidden="true">
              <path d="M8 22.5L24 9l16 13.5V38a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V22.5z" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
              <path d="M18 40V26h12v14" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
            </svg>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.45 }}
            style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '1.35rem',
              fontWeight: 800,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: '#fff'
            }}
          >
            {siteInfo.brandName}
          </motion.div>

          <motion.div
            initial={{ scaleX: 0, opacity: 0 }}
            animate={{ scaleX: 1, opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.7 }}
            style={{
              width: '96px',
              height: '2px',
              background: 'linear-gradient(90deg, transparent, var(--gold), transparent)'
            }}
          />

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.65 }}
            transition={{ delay: 1, duration: 0.5 }}
            style={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: '0.75rem',
              letterSpacing: '0.22em',
              textTransform: 'uppercase'
            }}
          >
            Preston · Property Investment
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
